<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter_One_Stalins_Armoured_Fist">
<p class="centerImage"><img alt="images" id="pg_8_1" src="images/pg_8_1.jpg"/></p>
<p class="caption">In the 1930s much of the Red Army’s armour comprised the BT (<em class="italic">Bystrokhodnii</em>) fast tank; the BT-5 (in fact a copy of the US Christie M-1931) is identifiable by its cylindrical turret housing a 45mm gun. The BT was unusual in that it could run on roads at high speeds off its tracks; with a crew of three and a weight of 11.5 tons it could manage 70mph. However, it was time-consuming taking the tracks off and in a country lacking paved roads was not a great asset. (<em class="italic">Author’s Collection</em>)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_01_Chapter_One.vue?e21b2cc0